import { ErrorModel } from '@era/app';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

// ============================================================================
// SIGNALR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const SignalRActions = createActionGroup({
  source: 'SignalR',
  events: {
    'Active device syncs updated': props<{ currentActiveSyncs: number }>(),
  },
});

export const DeviceActiveSyncsResolverActions = createActionGroup({
  source: 'Device Active Syncs Resolver',
  events: {
    'Device active sync count requested': emptyProps(),
  },
});

export const DeviceActiveSyncsApiActions = createActionGroup({
  source: 'Device Active Syncs API',
  events: {
    'Device active sync count loaded': props<{ currentActiveSyncs: number }>(),
    'Device active sync count loaded error': props<{ error: ErrorModel }>(),
  },
});
